module.exports = __webpack_public_path__ + "img/product-1-thumb-8.8669876d.jpg";